import { useTranslation } from "react-i18next"

import { Label } from "@/components/ui/label"
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "@/components/ui/select"
import { useStreamingCursor } from "@/hooks/use-streaming-cursor"

export function StreamingCursorSelector() {
  const { t } = useTranslation()
  const { cursorStyle, setCursorStyle, cursorStyles } = useStreamingCursor()

  const selectedData = cursorStyles.find((s) => s.id === cursorStyle)
  const selectStyleLabel = t("settings.streaming_cursor_select_style")

  return (
    <section className="flex flex-col gap-2">
      <Label className="text-sm font-medium">{t("settings.streaming_cursor")}</Label>
      <Select value={cursorStyle} onValueChange={(v) => setCursorStyle(v as typeof cursorStyle)}>
        <SelectTrigger className="h-auto min-h-[2.5rem] w-full py-2 [&>span]:line-clamp-none">
          <SelectValue placeholder={selectStyleLabel}>
            {selectedData ? (
              <div className="flex flex-col items-start gap-0.5 text-left">
                <span className="leading-tight font-medium">{t(selectedData.nameKey)}</span>
                <span className="text-muted-foreground text-xs leading-tight">
                  {t(selectedData.descriptionKey)}
                </span>
              </div>
            ) : (
              selectStyleLabel
            )}
          </SelectValue>
        </SelectTrigger>
        <SelectContent className="max-h-[50vh]" position="popper" sideOffset={4}>
          {cursorStyles.map((style) => (
            <SelectItem key={style.id} className="py-2.5" value={style.id}>
              <div className="flex flex-col items-start gap-0.5">
                <span className="leading-tight font-medium">{t(style.nameKey)}</span>
                <span className="text-muted-foreground text-xs leading-tight">
                  {t(style.descriptionKey)}
                </span>
              </div>
            </SelectItem>
          ))}
        </SelectContent>
      </Select>
      <p className="text-muted-foreground text-xs leading-relaxed">
        {t("settings.streaming_cursor_description")}
      </p>
    </section>
  )
}
